import React from "react";
import logoUrl from "../assets/logo.png";

/** لوگوی سامانه از فایل PNG */
export default function Logo({ size = 56, light = false }) {
  return (
    <img
      src={logoUrl}
      alt="لوگوی ایمنی بندر چارک"
      width={size}
      height={size}
      style={{
        objectFit: "contain",
        display: "block",
      }}
    />
  );
}